var ApiHelper = /** @class */ (function () {
    function ApiHelper(basePath) {
        if (basePath === void 0) { basePath = "/api"; }
        this.basePath = basePath;
    }
    ApiHelper.prototype.createUrl = function (path) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var url = this.basePath + "/" + path;
        for (var i = 0; i < params.length; i++) {
            var param = params[i];
            if (param !== null) {
                url += "/" + param;
            }
        }
        return url;
    };
    return ApiHelper;
}());
export { ApiHelper };
